export const Schema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Agile Infoways LLC",
  alternateName: "Agile Infoways",
  url: "https://www.agileinfoways.com/",
  logo: "https://www.agileinfoways.com/images/agile-logo-black.svg",
  sameAs: [
    "https://www.facebook.com/AgileInfoways",
    "https://twitter.com/agileinfoways",
    "https://www.instagram.com/agileinfoways/",
    "https://www.youtube.com/agileinfowayspvtltd",
    "https://www.linkedin.com/company/agile-infoways-pvt-ltd-",
    "https://www.pinterest.com/agile_infoways/",
    "",
  ],
}
